module.exports = __webpack_public_path__ + "img/core-values.c14b49e1.jpg";